



import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import DefaultTable from '@/views/formList/defaultTable.vue'

@Component({
  components: {
    DefaultTable
  }
})
export default class PcHomeSet extends Vue {
  handlePreview() {
    console.log('预览')
    const url = `https://www.eves.com.cn/activity?id=${this.$route.query.id}`
    window.open(url, '_blank')
  }
}
